/*
* Auth0 authentication callback. Redirects to dash if successful (or home if not)
*/

import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import * as ReduxQueries from '../queries';
import Auth from '../auth/auth';
import { NavigationLinks } from '../common/navigation';

class LoginCallback extends AppComp.AppComponent<any, any> {
  public constructor(props: any) {
    super(props, 'app.login-callback.');
  }

  public componentDidMount() {
    const auth = new Auth();
    if (!auth.isAuthenticated()) {
      auth.enforceAuthentication(this.props.location, this.props.navigateTo);
    } else {
      this.props.navigateTo(NavigationLinks.userDashboard());
    }
  }

  public render() {
    return (
      <div className="Login" />
    );
  }
}

const mapStateToProps = (state, props) => {
  return ReduxQueries.MapQueryStateToPropsRoot(state, props);
};

const mapDispatchToProps = {
  navigateTo: (path) => push(path)
};

const LoginCallbackContainer = compose<any>(
  connect(mapStateToProps, mapDispatchToProps),
)(LoginCallback);

export default withRouter(LoginCallbackContainer);



// WEBPACK FOOTER //
// ./src/login/callback.tsx